import { leftpad, angleReflect } from './utils';
const Phaser = window?.Phaser;
export class SinglePlayerEndless extends window.Phaser.Scene {
  constructor() {
    super('singlePlayerEndless');
  }

  preload() {
    this.score = 0;
    this.load.image('wall', '/assets/delivery-guy/wall.png');
    this.load.image('bg', '/assets/delivery-guy/game-bg.png');
    this.load.image('direction', '/assets/delivery-guy/direction.png');
    this.load.spritesheet(
      'hero-bird',
      '/assets/delivery-guy/sprite-drone.png',
      {
        frameWidth: 110,
        frameHeight: 110,
      }
    );
    //  .scale.setTo(55 / 110, 55 / 110);
    // .setDisplaySize(180, 80);

    /*
    this.load.spritesheet('sprite-play', '/assets/delivery-guy/sprite-play.png', { 
      frameWidth: 55, 
      frameHeight: 55
    });
    this.load.spritesheet('sprite-pause', '/assets/delivery-guy/sprite-pause.png', { 
      frameWidth: 37, 
      frameHeight: 37
    });
    */
    this.load.spritesheet(
      'sprite-bomb',
      '/assets/delivery-guy/sprite-bomb.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-radar',
      '/assets/delivery-guy/sprite-radar.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-orange',
      '/assets/delivery-guy/sprite-radar.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-pear',
      '/assets/delivery-guy/sprite-radar.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-banana',
      '/assets/delivery-guy/sprite-radar.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
  }

  create() {
    const areaWidth = 306;
    const areaHeight = 406;
    this.gameWidth = this.sys.game.canvas.width;
    this.gameHeight = this.sys.game.canvas.height;

    this.birdAngle = -90;
    this.birdVelocity = 300;
    this.birdAngularVelocity = 200;
    this.defaultNumBombs = 4;
    this.numBombs = 4;
    this.spacesCount = 160;
    this.bouncingLR = false;
    this.bouncingTB = false;
    this.goBird = false;
    this.spaces = new Uint8Array(this.spacesCount);
    this.canContinue = true;

    const bg = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg')
      .setDisplaySize(this.cameras.main.width, this.cameras.main.height);

    var graphics = this.add.graphics();
    graphics.lineStyle(2, 0x79bd26); // starting point 85, 87
    graphics.strokeRect(87, 87, areaWidth, 2, 1);
    graphics.strokeRect(85, 89, 2, areaHeight, 1);
    graphics.strokeRect(87, 497, areaWidth, 2, 1);
    graphics.strokeRect(393, 89, 2, areaHeight, 1);
    // graphics.lineStyle(2, 0x9badb7);
    // graphics.strokeRect(89, 91, 302, 2, 1);
    // graphics.strokeRect(85, 499, 2, 2, 1);
    // graphics.strokeRect(87, 501, 306, 2, 1);
    // graphics.strokeRect(393, 399, 2, 2, 1);

    this.wallsLR = this.add.group();
    this.wallsTB = this.add.group();

    let wallLeft = this.wallsLR.create(83, 90, 'wall');
    wallLeft.setScale(5, areaHeight);
    wallLeft.setOrigin(0, 0);
    this.physics.world.enable(wallLeft);

    let wallTop = this.wallsTB.create(83, 85, 'wall');
    wallTop.setScale(areaWidth + 10, 5);
    wallTop.setOrigin(0, 0);
    this.physics.world.enable(wallTop);

    let wallRight = this.wallsLR.create(392, 90, 'wall');
    wallRight.setScale(5, areaHeight);
    wallRight.setOrigin(0, 0);
    this.physics.world.enable(wallRight);

    let wallBottom = this.wallsTB.create(83, 496, 'wall');
    wallBottom.setScale(areaWidth + 10, 5);
    wallBottom.setOrigin(0, 0);
    this.physics.world.enable(wallBottom);

    this.coins = this.add.group();
    this.bombs = this.add.group();

    this.bird = this.physics.add.sprite(
      this.gameWidth / 2,
      this.gameHeight / 2,
      'hero-bird'
    );
    this.bird.setScale(0.4);
    this.anims.create({
      key: 'bye',
      frames: this.anims.generateFrameNumbers('hero-bird', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'hover',
      frames: this.anims.generateFrameNumbers('hero-bird', { frames: [0] }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'fly',
      frames: this.anims.generateFrameNumbers('hero-bird', {
        frames: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      }),
      frameRate: 12.5,
      repeat: -1,
    });
    this.bird.setOrigin(0.5, 0.5);
    this.bird.body.setSize(24, 24);
    this.bird.angle = this.birdAngle;
    this.bird.alpha = 0;
    this.bird.playable = true;
    this.bird.bouncingTB = false;
    this.bird.bouncingLR = false;
    this.tweens.add({
      targets: this.bird,
      alpha: 1,
      duration: 200,
      repeat: 0,
      ease: 'quad.in',
      onUpdate: (tween, target) => {
        // `target` is the sprite being animated
        console.log('Current Position:', target.x, target.y);
      },
    });
    this.bird.allowGravity = false;
    this.bird.setCollideWorldBounds(true);
    this.bird.body.bounce.set(1, 1);
    this.bird.setAngularVelocity(this.birdAngularVelocity);

    this.bird.anims.play('hover');

    // create fruit animations
    this.anims.create({
      key: 'apple-bye',
      frames: this.anims.generateFrameNumbers('sprite-radar', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'orange-bye',
      frames: this.anims.generateFrameNumbers('sprite-orange', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'pear-bye',
      frames: this.anims.generateFrameNumbers('sprite-pear', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'banana-bye',
      frames: this.anims.generateFrameNumbers('sprite-banana', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });

    // create bomb animations
    this.anims.create({
      key: 'bomb-shine',
      frames: this.anims.generateFrameNumbers('sprite-bomb', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'bomb-bye',
      frames: this.anims.generateFrameNumbers('sprite-bomb', {
        frames: [10, 11, 12, 13, 14, 15, 16],
      }),
      frameRate: 12.5,
      repeat: 0,
    });

    this.createACoin(true);

    for (var i = 0; i < this.numBombs; i++) {
      this.createABomb();
    }
    this.scoreText = this.add
      .bitmapText(
        this.cameras.main.width / 2 - 30,
        62,
        'pixelfont',
        leftpad(this.score, 3),
        20
      )
      .setOrigin(0, 0);

    this.flyRect = this.add
      .rectangle(this.gameWidth / 2, 560, 580, 68)
      .setOrigin(0.5, 0.5)
      .setInteractive()
      .on('pointerdown', () => this.makeBirdGo())
      .on('pointerup', () => this.makeBirdStop())
      .on('pointerout', () => this.makeBirdStop());
      const flyButton = this.add
        .image(this.gameWidth / 2, this.gameHeight - 50, 'direction')
        // .setOrigin(0.5, 0.5)
        // .setInteractive({ useHandCursor: true })
      .setDisplaySize(75,75)
    // this.flyButton = this.add
    //   .bitmapText(this.gameWidth / 2, 540, 'pixelfont', '<>', 24)
      .setOrigin(0.5, 0.5)
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.makeBirdGo())
      .on('pointerup', () => this.makeBirdStop())
      .on('pointerout', () => this.makeBirdStop());

    this.input.keyboard.on('keydown', this.handleKeyboardDown, this);
    this.input.keyboard.on('keyup', this.handleKeyboardUp, this);

    if (this.input.gamepad.total < 1) {
      this.input.gamepad.once(
        'connected',
        function (pad) {
          this.input.gamepad.on('down', this.handleGamePadDown, this);
          this.input.gamepad.on('up', this.handleGamePadUp, this);
        },
        this
      );
    } else {
      this.input.gamepad.on('down', this.handleGamePadDown, this);
      this.input.gamepad.on('up', this.handleGamePadUp, this);
    }

    this.bird.body.onOverlap = true;

    this.events.on('shutdown', this.shutdown, this);


  }

  update() {
    this.physics.world.overlap(
      this.bird,
      this.wallsLR,
      this.birdBounceLR,
      null,
      this
    );
    this.physics.world.overlap(
      this.bird,
      this.wallsTB,
      this.birdBounceTB,
      null,
      this
    );
    this.physics.world.overlap(
      this.bird,
      this.coins,
      this.collectCoin,
      null,
      this
    );
    this.physics.world.overlap(this.bird, this.bombs, this.hitBomb, null, this);

    if (this.goBird && this.bird.playable) {
      this.bird.setAngularVelocity(0);
      this.physics.velocityFromAngle(
        this.bird.angle,
        this.birdVelocity,
        this.bird.body.velocity
      );
    } else {
      this.bird.setAngularVelocity(this.birdAngularVelocity);
      this.bird.setVelocity(0, 0);
    }
  }

  shutdown() {
    //  We need to clear keyboard and gamepad events, or they'll stack up when the Menu is re-run
    this.input.keyboard.shutdown();
    this.input.gamepad.shutdown();
  }

  handleKeyboardDown(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.J:
      case Phaser.Input.Keyboard.KeyCodes.K:
      case Phaser.Input.Keyboard.KeyCodes.SPACE:
        this.makeBirdGo();
        break;
    }
  }

  handleKeyboardUp(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.J:
      case Phaser.Input.Keyboard.KeyCodes.K:
      case Phaser.Input.Keyboard.KeyCodes.SPACE:
        this.makeBirdStop();
        break;
    }
  }

  handleGamePadDown(pad, button, value) {
    switch (button.index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        this.makeBirdGo();
        break;
    }
  }

  handleGamePadUp(pad, button, value) {
    switch (button.index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        this.makeBirdStop();
        break;
    }
  }

  makeBirdGo() {
    if (!this.goBird) {
      this.goBird = true;
      if (this.bird.playable) {
        this.bird.anims.play('fly');
      }
    }
  }

  makeBirdStop() {
    this.goBird = false;
    if (this.bird.playable) {
      this.bird.anims.play('hover');
    }
  }

  birdBounceLR(bird, wall) {
    if (!bird.playable || bird.bouncingLR) {
      return;
    }
    bird.playable = false;
    bird.bouncingLR = true;
    bird.body.velocity.set(0, 0);
    bird.angle = angleReflect(bird.angle, 90);
    if (bird.x > wall.x) {
      bird.x += 8;
    } else {
      bird.x -= 8;
    }
    this.physics.velocityFromAngle(
      bird.angle,
      this.birdVelocity,
      bird.body.velocity
    );
    bird.bouncingLR = false;
    bird.playable = true;
  }

  birdBounceTB(bird, wall) {
    if (!bird.playable || bird.bouncingTB) {
      return;
    }
    bird.playable = false;
    bird.bouncingTB = true;
    bird.body.velocity.set(0, 0);
    bird.angle = angleReflect(bird.angle, 0);
    if (bird.y > wall.y) {
      bird.y += 8;
    } else {
      bird.y -= 8;
    }
    this.physics.velocityFromAngle(
      bird.angle,
      this.birdVelocity,
      bird.body.velocity
    );
    bird.bouncingTB = false;
    bird.playable = true;
  }

  getAvailableSpace() {
    var bird_index =
      parseInt((this.bird.x - 106.5) / 25) +
      11 * parseInt((this.bird.y - 102.5) / 25);
    var bird_indexes = [
      bird_index - 12,
      bird_index - 11,
      bird_index - 10,
      bird_index - 9,
      bird_index - 1,
      bird_index,
      bird_index + 1,
      bird_index + 2,
      bird_index + 9,
      bird_index + 10,
      bird_index + 11,
      bird_index + 12,
    ];

    var available_spaces = [];
    for (var i = 0; i < this.spaces.length; i++) {
      if (this.spaces[i] == 0 && bird_indexes.indexOf(i) < 0) {
        available_spaces.push(i);
      }
    }
    if (available_spaces.length < 1) {
      return false;
    }
    var rand_index =
      available_spaces[Math.floor(Math.random() * available_spaces.length)];
    var y_index = parseInt(rand_index / 11);
    var x_index = parseInt(rand_index % 11);
    var x = x_index * 25 + 120;
    var y = y_index * 25 + 120;
    return { index: rand_index, x: x, y: y };
  }

  createACoin(first) {
    let available_location = this.getAvailableSpace();
    if (available_location === false) {
      return;
    }
    this.spaces[available_location.index] = 1; // for a coin
    let opportunity = Math.min(this.score * 3, 49);
    let selection = Math.floor(Math.random() * opportunity);
    let value = 1;
    if (selection >= 45) {
      selection = 'sprite-banana';
      value = 100;
    } else if (selection >= 35) {
      selection = 'sprite-pear';
      value = 90;
    } else if (selection >= 20) {
      selection = 'sprite-orange';
      value = 80;
    } else {
      selection = 'sprite-radar';
      value = 70;
    }
    let a_coin = this.add.sprite(
      available_location.x,
      available_location.y,
      selection
    );
    a_coin.setAlpha(0.1);
    a_coin.coin_value = value;
    this.tweens.add({
      targets: a_coin,
      alpha: 1,
      duration: 200,
      repeat: 0,
      ease: 'quad.in',
    });
    this.physics.world.enable(a_coin);
    if (selection == 'sprite-banana') {
      a_coin.body.setSize(17, 15);
      a_coin.body.setOffset(20, 22);
    } else if (selection == 'sprite-pear') {
      a_coin.body.setSize(13, 16);
      a_coin.body.setOffset(22, 22);
    } else if (selection == 'sprite-orange') {
      a_coin.body.setSize(16, 14);
      a_coin.body.setOffset(20, 22);
    } else {
      a_coin.body.setSize(16, 14);
      a_coin.body.setOffset(20, 22);
    }
    a_coin.allowGravity = false;
    this.coins.add(a_coin);
  }

  createABomb() {
    let available_location = this.getAvailableSpace();
    if (available_location === false) {
      return;
    }
    this.spaces[available_location.index] = 2; // for a bomb
    let adj_index = available_location.index - 12;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 9;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 2;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 9;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    let rand_x = Math.floor(Math.random() * 5) - 2;
    let rand_y = Math.floor(Math.random() * 5) - 2;

    let a_bomb = this.add.sprite(
      available_location.x + rand_x,
      available_location.y + rand_y,
      'sprite-bomb'
    );
    this.physics.world.enable(a_bomb);
    a_bomb.body.setSize(24, 24);
    a_bomb.body.setOffset(16, 15);
    a_bomb.allowGravity = false;
    this.bombs.add(a_bomb);

    a_bomb.setAlpha(0.1);
    this.tweens.add({
      targets: a_bomb,
      alpha: 1,
      duration: 200,
      repeat: 0,
      ease: 'quad.in',
    });
    a_bomb.anims.play('bomb-shine');
  }

  hitBomb(bird, bomb) {
    if (!bird.playable) {
      return;
    }
    if (bomb.alpha < 1) {
      return;
    } // bomb must be a valid threat!

    this.sound.play('ouch');
    bird.playable = false;
    bird.anims.play('bye');
    bomb.anims.play('bomb-bye');
    bird.on(
      'animationcomplete',
      () => {
        this.scene.start('gameOver', {
          score: this.score,
          mode: 'Single Player Endless',
        }); // with num players
      },
      this
    );
  }

  killBomb(bomb) {
    this.bombs.remove(bomb);
    let killBombTween = this.tweens.add({
      targets: bomb,
      alpha: 0,
      duration: 200,
      repeat: 0,
      ease: 'quad.out',
    });
    killBombTween.on(
      'complete',
      () => {
        bomb.destroy();
      },
      this
    );
  }

  collectCoin(bird, coin) {

    if (!bird.playable) {
      return;
    }

    let animationKey = 'apple-bye';
    let soundKey = 'apple';
    if (coin.coin_value == 100) {
      animationKey = 'banana-bye';
      soundKey = 'banana';
    } else if (coin.coin_value == 90) {
      animationKey = 'pear-bye';
      soundKey = 'pear';
    } else if (coin.coin_value == 70) {
      animationKey = 'orange-bye';
      soundKey = 'orange';
    }
    this.coins.remove(coin);
    this.sound.play(soundKey);
    coin.anims.play(animationKey);
    this.score += coin.coin_value;
    this.scoreText.text = leftpad(this.score, 3);
    window.sendGameMessage(JSON.stringify({ score: this.score, numBombs: this.numBombs, game: "drone" }));

    coin.on(
      'animationcomplete',
      () => {
        coin.destroy();
        this.bombs.children.each(function (a_bomb) {
          if (true || a_bomb.active) {
            this.killBomb(a_bomb);
          }
        }, this);
        if (this.score % 3 == 0) {
          this.numBombs = this.defaultNumBombs + Math.floor(this.defaultNumBombs / 3);
        }
        // if (this.score >= 40) {
        //   this.numBombs = this.defaultNumBombs + 4;
        // } else if (this.score >= 30) {
        //   this.numBombs = this.defaultNumBombs + 3;
        // } else if (this.score >= 20) {
        //   this.numBombs = this.defaultNumBombs + 2;
        // } else {
        //   this.numBombs = this.defaultNumBombs;
        // }

        this.birdVelocity += 5;
        this.birdAngularVelocity += 5;

        this.spaces = new Uint8Array(this.spacesCount);
        for (let i = 0; i < this.numBombs; i++) {
          this.createABomb();
        }

        this.createACoin();
      },
      this
    );
  }
}
